import { useState } from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
const servicesData = [{
  title: "CUSTOM HOME BUILDS",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_custom_home_austin_no_figure.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_custom_home_austin.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_custom_home_austin.png-wvc-sizes",
  alt: "Luxury custom home construction in Austin"
}, {
  title: "RESIDENTIAL REMODELING",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/residential_remodeling_austin.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/residential_remodeling_austin.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/residential_remodeling_austin.png-wvc-sizes",
  alt: "High-end residential remodeling project"
}, {
  title: "KITCHEN REMODELING",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_kitchen_renovation.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_kitchen_renovation.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_kitchen_renovation.png-wvc-sizes",
  alt: "Modern luxury kitchen renovation"
}, {
  title: "BATHROOM REMODELING",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_neutral_bathroom_austin.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_neutral_bathroom_austin.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_neutral_bathroom_austin.png-wvc-sizes",
  alt: "Luxury neutral-tone bathroom remodel in Austin"
}, {
  title: "HOME ADDITIONS",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_neutral_home_addition.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_neutral_home_addition.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_neutral_home_addition.png-wvc-sizes",
  alt: "Luxury neutral-tone modern home addition"
}, {
  title: "GENERAL CONTRACTING",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_home_framing_stage.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_home_framing_stage.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_home_framing_stage.png-wvc-sizes",
  alt: "Modern two-story residential home in the framing construction stage"
}];
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/Project-AR2332.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/Project-AR2332.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/Project-AR2332.jpg-wvc-sizes",
  alt: "Luxury custom home architecture and design"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/OIG1-9.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/OIG1-9.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/OIG1-9.jpg-wvc-sizes",
  alt: "Luxury custom home architectural design"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_4.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_4.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_4.png-wvc-sizes",
  alt: "High-end kitchen craftsmanship"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_5.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_5.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_5.png-wvc-sizes",
  alt: "Master suite luxury finish"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_walkway.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_walkway.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_walkway.png-wvc-sizes",
  alt: "Walkway in greener hill country"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_7.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_7.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_7.png-wvc-sizes",
  alt: "Custom staircase design"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_8_elegant.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_8_elegant.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_8_elegant.png-wvc-sizes",
  alt: "Elegant modern farmhouse bathroom"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_kitchen_luxe.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_kitchen_luxe.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_kitchen_luxe.png-wvc-sizes",
  alt: "Luxury custom kitchen"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_10.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_10.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/gallery_custom_home_10.png-wvc-sizes",
  alt: "Custom home night view"
}];
const residentialRemodel = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_1.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_1.png-wvc-sizes",
  alt: "Residential remodel project 1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_2.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_2.png-wvc-sizes",
  alt: "Residential remodel project 2"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_3.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_3.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_3.png-wvc-sizes",
  alt: "Residential remodel project 3"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_5.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_5.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_5.png-wvc-sizes",
  alt: "Residential remodel project 5"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_6.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_6.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_6.png-wvc-sizes",
  alt: "Residential remodel project 6"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_7.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_7.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_7.png-wvc-sizes",
  alt: "Residential remodel project 7"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_8.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_8.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/remodel_8.png-wvc-sizes",
  alt: "Residential remodel project 8"
}];
const kitchenRemodel = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_1.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_1.png-wvc-sizes",
  alt: "Modern luxury kitchen remodel view 1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_2.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_2.png-wvc-sizes",
  alt: "Modern luxury kitchen remodel view 2"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_3.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_3.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_3.png-wvc-sizes",
  alt: "Modern luxury kitchen remodel view 3"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_4.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_4.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_4.png-wvc-sizes",
  alt: "Modern luxury kitchen remodel view 4"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_5.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_5.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/kitchen_remodel_5.png-wvc-sizes",
  alt: "Modern luxury kitchen remodel view 5"
}];
const bathroomRemodel = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/bathroom_remodel_1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/bathroom_remodel_1.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/bathroom_remodel_1.png-wvc-sizes",
  alt: "Modern transitional bathroom design with luxury wood flooring view 1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/bathroom_remodel_2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/bathroom_remodel_2.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/bathroom_remodel_2.png-wvc-sizes",
  alt: "Modern transitional bathroom design with luxury wood flooring view 2"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/bathroom_remodel_3.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/bathroom_remodel_3.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/bathroom_remodel_3.png-wvc-sizes",
  alt: "Modern transitional bathroom design with luxury wood flooring view 3"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_bathroom_vanity_austin.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_bathroom_vanity_austin.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_bathroom_vanity_austin.png-wvc-sizes",
  alt: "High-end custom bathroom vanity with marble countertops"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_spa_bathroom_remodel.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_spa_bathroom_remodel.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_spa_bathroom_remodel.png-wvc-sizes",
  alt: "Modern spa-like bathroom remodel with walk-in shower"
}];
const homeAdditions = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_deck_addition.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_deck_addition.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_deck_addition.png-wvc-sizes",
  alt: "Luxury custom deck and outdoor living space addition"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_deck_addition_alt.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_deck_addition_alt.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_deck_addition_alt.png-wvc-sizes",
  alt: "Alternative view of luxury custom deck addition"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_sunroom_addition.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_sunroom_addition.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_sunroom_addition.png-wvc-sizes",
  alt: "Modern glass sunroom home addition"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_sunroom_addition_interior.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_sunroom_addition_interior.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_sunroom_addition_interior.png-wvc-sizes",
  alt: "Interior view of modern sunroom addition"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/custom_pergola_addition.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/custom_pergola_addition.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/custom_pergola_addition.png-wvc-sizes",
  alt: "Custom architectural pergola addition"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_guest_suite_addition.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_guest_suite_addition.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_guest_suite_addition.png-wvc-sizes",
  alt: "Modern guest suite home addition"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_outdoor_kitchen.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_outdoor_kitchen.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_outdoor_kitchen.png-wvc-sizes",
  alt: "Luxury outdoor kitchen and entertainment area"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_pool_house.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_pool_house.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/modern_pool_house.png-wvc-sizes",
  alt: "Modern luxury pool house addition"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_patio_renovation.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_patio_renovation.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_patio_renovation.png-wvc-sizes",
  alt: "High-end luxury patio renovation"
}];
export default function OurExpertise() {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [isResidentialGalleryOpen, setIsResidentialGalleryOpen] = useState(false);
  const [isKitchenGalleryOpen, setIsKitchenGalleryOpen] = useState(false);
  const [isBathroomGalleryOpen, setIsBathroomGalleryOpen] = useState(false);
  const [isHomeAdditionsGalleryOpen, setIsHomeAdditionsGalleryOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const nextImage = (images: any[]) => {
    if (currentImageIndex < images.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };
  const prevImage = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };
  return <section data-section-id="259369" id="our-expertise" className="dark bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/green_hill_country_austin.png)] text-foreground w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
        {servicesData.map((service, i) => <div key={i} data-index={i} className={`group relative overflow-hidden w-full ${i === 0 || i === 1 || i === 2 || i === 3 || i === 4 ? 'cursor-pointer' : ''}`} onClick={() => {
        if (i === 0) {
          setCurrentImageIndex(0);
          setIsGalleryOpen(true);
        } else if (i === 1) {
          setCurrentImageIndex(0);
          setIsResidentialGalleryOpen(true);
        } else if (i === 2) {
          setCurrentImageIndex(0);
          setIsKitchenGalleryOpen(true);
        } else if (i === 3) {
          setCurrentImageIndex(0);
          setIsBathroomGalleryOpen(true);
        } else if (i === 4) {
          setCurrentImageIndex(0);
          setIsHomeAdditionsGalleryOpen(true);
        }
      }}>
            <AspectRatio ratio={1}>
              <img src={service.src} data-wvc-srcset={service.srcset} data-wvc-sizes={service.sizes} alt={service.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
              <div className="absolute inset-0 bg-black/60 transition-colors duration-500 group-hover:bg-black/40" />
              <div className="absolute inset-0 flex items-center justify-center p-6 text-center">
                <h3 className="font-default text-2xl md:text-3xl font-bold text-white tracking-widest uppercase">
                  {service.title}
                </h3>
              </div>
            </AspectRatio>
          </div>)}
      </div>

      {isGalleryOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm transition-opacity duration-300">
          <div className="absolute inset-0" onClick={() => setIsGalleryOpen(false)} />
          
          <div className="relative z-10 w-full max-w-6xl px-4 flex flex-col items-center">
            <button onClick={() => setIsGalleryOpen(false)} className="absolute top-[-60px] right-4 md:right-0 text-white hover:text-secondary transition-colors p-2" aria-label="Close gallery">
              <X className="w-8 h-8" />
            </button>

            <div className="relative w-full flex items-center justify-center">
              <button onClick={() => prevImage()} disabled={currentImageIndex === 0} className="absolute left-0 md:left-[-80px] z-20 text-white disabled:opacity-20 hover:text-secondary transition-colors p-2">
                <ChevronLeft className="w-10 h-10" />
              </button>

              <div className="w-full max-h-[70vh] md:max-h-[80vh] overflow-hidden flex items-center justify-center">
                <img src={galleryImages[currentImageIndex].src} data-wvc-srcset={galleryImages[currentImageIndex].srcset} data-wvc-sizes={galleryImages[currentImageIndex].sizes} alt={galleryImages[currentImageIndex].alt} className="max-w-full max-h-full object-contain" />
              </div>

              <button onClick={() => nextImage(galleryImages)} disabled={currentImageIndex === galleryImages.length - 1} className="absolute right-0 md:right-[-80px] z-20 text-white disabled:opacity-20 hover:text-secondary transition-colors p-2">
                <ChevronRight className="w-10 h-10" />
              </button>
            </div>

            <div className="mt-8 flex flex-col items-center gap-4">
              <div className="text-white font-mono text-sm tracking-widest uppercase">
                {currentImageIndex + 1} / {galleryImages.length}
              </div>
              
              <div className="flex gap-2">
                {galleryImages.map((_, idx) => <button key={idx} onClick={() => setCurrentImageIndex(idx)} className={`w-2 h-2 transition-all duration-300 ${currentImageIndex === idx ? 'bg-white w-6' : 'bg-white/30 hover:bg-white/60'}`} aria-label={`Go to image ${idx + 1}`} />)}
              </div>
            </div>
          </div>
        </div>}

      {isResidentialGalleryOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm transition-opacity duration-300">
          <div className="absolute inset-0" onClick={() => setIsResidentialGalleryOpen(false)} />
          
          <div className="relative z-10 w-full max-w-6xl px-4 flex flex-col items-center">
            <button onClick={() => setIsResidentialGalleryOpen(false)} className="absolute top-[-60px] right-4 md:right-0 text-white hover:text-secondary transition-colors p-2" aria-label="Close gallery">
              <X className="w-8 h-8" />
            </button>

            <div className="relative w-full flex items-center justify-center">
              <button onClick={() => prevImage()} disabled={currentImageIndex === 0} className="absolute left-0 md:left-[-80px] z-20 text-white disabled:opacity-20 hover:text-secondary transition-colors p-2">
                <ChevronLeft className="w-10 h-10" />
              </button>

              <div className="w-full max-h-[70vh] md:max-h-[80vh] overflow-hidden flex items-center justify-center">
                <img src={residentialRemodel[currentImageIndex].src} data-wvc-srcset={residentialRemodel[currentImageIndex].srcset} data-wvc-sizes={residentialRemodel[currentImageIndex].sizes} alt={residentialRemodel[currentImageIndex].alt} className="max-w-full max-h-full object-contain" />
              </div>

              <button onClick={() => nextImage(residentialRemodel)} disabled={currentImageIndex === residentialRemodel.length - 1} className="absolute right-0 md:right-[-80px] z-20 text-white disabled:opacity-20 hover:text-secondary transition-colors p-2">
                <ChevronRight className="w-10 h-10" />
              </button>
            </div>

            <div className="mt-8 flex flex-col items-center gap-4">
              <div className="text-white font-mono text-sm tracking-widest uppercase">
                {currentImageIndex + 1} / {residentialRemodel.length}
              </div>
              
              <div className="flex gap-2">
                {residentialRemodel.map((_, idx) => <button key={idx} onClick={() => setCurrentImageIndex(idx)} className={`w-2 h-2 transition-all duration-300 ${currentImageIndex === idx ? 'bg-white w-6' : 'bg-white/30 hover:bg-white/60'}`} aria-label={`Go to image ${idx + 1}`} />)}
              </div>
            </div>
          </div>
        </div>}

      {isKitchenGalleryOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm transition-opacity duration-300">
          <div className="absolute inset-0" onClick={() => setIsKitchenGalleryOpen(false)} />
          
          <div className="relative z-10 w-full max-w-6xl px-4 flex flex-col items-center">
            <button onClick={() => setIsKitchenGalleryOpen(false)} className="absolute top-[-60px] right-4 md:right-0 text-white hover:text-secondary transition-colors p-2" aria-label="Close gallery">
              <X className="w-8 h-8" />
            </button>

            <div className="relative w-full flex items-center justify-center">
              <button onClick={() => prevImage()} disabled={currentImageIndex === 0} className="absolute left-0 md:left-[-80px] z-20 text-white disabled:opacity-20 hover:text-secondary transition-colors p-2">
                <ChevronLeft className="w-10 h-10" />
              </button>

              <div className="w-full max-h-[70vh] md:max-h-[80vh] overflow-hidden flex items-center justify-center">
                <img src={kitchenRemodel[currentImageIndex].src} data-wvc-srcset={kitchenRemodel[currentImageIndex].srcset} data-wvc-sizes={kitchenRemodel[currentImageIndex].sizes} alt={kitchenRemodel[currentImageIndex].alt} className="max-w-full max-h-full object-contain" />
              </div>

              <button onClick={() => nextImage(kitchenRemodel)} disabled={currentImageIndex === kitchenRemodel.length - 1} className="absolute right-0 md:right-[-80px] z-20 text-white disabled:opacity-20 hover:text-secondary transition-colors p-2">
                <ChevronRight className="w-10 h-10" />
              </button>
            </div>

            <div className="mt-8 flex flex-col items-center gap-4">
              <div className="text-white font-mono text-sm tracking-widest uppercase">
                {currentImageIndex + 1} / {kitchenRemodel.length}
              </div>
              
              <div className="flex gap-2">
                {kitchenRemodel.map((_, idx) => <button key={idx} onClick={() => setCurrentImageIndex(idx)} className={`w-2 h-2 transition-all duration-300 ${currentImageIndex === idx ? 'bg-white w-6' : 'bg-white/30 hover:bg-white/60'}`} aria-label={`Go to image ${idx + 1}`} />)}
              </div>
            </div>
          </div>
        </div>}

      {isBathroomGalleryOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm transition-opacity duration-300">
          <div className="absolute inset-0" onClick={() => setIsBathroomGalleryOpen(false)} />
          
          <div className="relative z-10 w-full max-w-6xl px-4 flex flex-col items-center">
            <button onClick={() => setIsBathroomGalleryOpen(false)} className="absolute top-[-60px] right-4 md:right-0 text-white hover:text-secondary transition-colors p-2" aria-label="Close gallery">
              <X className="w-8 h-8" />
            </button>

            <div className="relative w-full flex items-center justify-center">
              <button onClick={() => prevImage()} disabled={currentImageIndex === 0} className="absolute left-0 md:left-[-80px] z-20 text-white disabled:opacity-20 hover:text-secondary transition-colors p-2">
                <ChevronLeft className="w-10 h-10" />
              </button>

              <div className="w-full max-h-[70vh] md:max-h-[80vh] overflow-hidden flex items-center justify-center">
                <img src={bathroomRemodel[currentImageIndex].src} data-wvc-srcset={bathroomRemodel[currentImageIndex].srcset} data-wvc-sizes={bathroomRemodel[currentImageIndex].sizes} alt={bathroomRemodel[currentImageIndex].alt} className="max-w-full max-h-full object-contain" />
              </div>

              <button onClick={() => nextImage(bathroomRemodel)} disabled={currentImageIndex === bathroomRemodel.length - 1} className="absolute right-0 md:right-[-80px] z-20 text-white disabled:opacity-20 hover:text-secondary transition-colors p-2">
                <ChevronRight className="w-10 h-10" />
              </button>
            </div>

            <div className="mt-8 flex flex-col items-center gap-4">
              <div className="text-white font-mono text-sm tracking-widest uppercase">
                {currentImageIndex + 1} / {bathroomRemodel.length}
              </div>
              
              <div className="flex gap-2">
                {bathroomRemodel.map((_, idx) => <button key={idx} onClick={() => setCurrentImageIndex(idx)} className={`w-2 h-2 transition-all duration-300 ${currentImageIndex === idx ? 'bg-white w-6' : 'bg-white/30 hover:bg-white/60'}`} aria-label={`Go to image ${idx + 1}`} />)}
              </div>
            </div>
          </div>
        </div>}

      {isHomeAdditionsGalleryOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm transition-opacity duration-300">
          <div className="absolute inset-0" onClick={() => setIsHomeAdditionsGalleryOpen(false)} />
          
          <div className="relative z-10 w-full max-w-6xl px-4 flex flex-col items-center">
            <button onClick={() => setIsHomeAdditionsGalleryOpen(false)} className="absolute top-[-60px] right-4 md:right-0 text-white hover:text-secondary transition-colors p-2" aria-label="Close gallery">
              <X className="w-8 h-8" />
            </button>

            <div className="relative w-full flex items-center justify-center">
              <button onClick={() => prevImage()} disabled={currentImageIndex === 0} className="absolute left-0 md:left-[-80px] z-20 text-white disabled:opacity-20 hover:text-secondary transition-colors p-2">
                <ChevronLeft className="w-10 h-10" />
              </button>

              <div className="w-full max-h-[70vh] md:max-h-[80vh] overflow-hidden flex items-center justify-center">
                <img data-wvc-srcset={homeAdditions[currentImageIndex].srcset} data-wvc-sizes={homeAdditions[currentImageIndex].sizes} alt={homeAdditions[currentImageIndex].alt} className="max-w-full max-h-full object-contain" src="https://gfccontractors.com/wp-content/uploads/2026/05/OIG3.cDOR5rB0xKuW1NxJn.jpeg" />
              </div>

              <button onClick={() => nextImage(homeAdditions)} disabled={currentImageIndex === homeAdditions.length - 1} className="absolute right-0 md:right-[-80px] z-20 text-white disabled:opacity-20 hover:text-secondary transition-colors p-2">
                <ChevronRight className="w-10 h-10" />
              </button>
            </div>

            <div className="mt-8 flex flex-col items-center gap-4">
              <div className="text-white font-mono text-sm tracking-widest uppercase">
                {currentImageIndex + 1} / {homeAdditions.length}
              </div>
              
              <div className="flex gap-2">
                {homeAdditions.map((_, idx) => <button key={idx} onClick={() => setCurrentImageIndex(idx)} className={`w-2 h-2 transition-all duration-300 ${currentImageIndex === idx ? 'bg-white w-6' : 'bg-white/30 hover:bg-white/60'}`} aria-label={`Go to image ${idx + 1}`} />)}
              </div>
            </div>
          </div>
        </div>}
    </section>;
}